import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Offer } from '../../model/offer';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { OfferService } from '../../_services/offer/offer.service';
import { ActivatedRoute, Router} from '@angular/router';
import { SharedService } from '../../_services/shared.service';
import { AuthService } from '../../_services/auth.service';
import { Notifications } from '../../enum/notifications';
import { Observable, shareReplay } from 'rxjs';
import { GuestDTO } from '../../model/guestDTO';
import { ShoppingCartService } from '../../_services/shopping-cart.service';
import { ShoppingCartTableComponent } from '../shopping-cart-table/shopping-cart-table.component';
import { LxViewportDirective } from '../../directives/lx-viewport.directive';
import {LxResponsiveClassDirective} from "../../directives/lx-responsive-class.directive";
import { ThemeService } from '../../_services/theme.service';

@Component({
    selector: 'app-offer-photo-terms',
    standalone: true,
  imports: [
    CommonModule,
    ShoppingCartTableComponent,
    LxViewportDirective,
    LxResponsiveClassDirective
  ],
    templateUrl: './offer-photo-terms.component.html',
    styleUrl: './offer-photo-terms.component.scss'
})
export class OfferPhotoTermsComponent implements OnInit {

  @Input() offer!: Offer | null;
  @Input() offers: Offer[] = [];
  @Input() propertyId: string = '';
  @Input() offerAliasId: string = '';

  offerPhotoTermsReference: any;
  acknowledgment: boolean = false;


  constructor(private authService: AuthService,
              private offerService: OfferService,
              private router: Router,
              private route: ActivatedRoute,
              public sharedService: SharedService,
              public shoppingCartService: ShoppingCartService,
              public modalRef: BsModalRef,
              public themeService: ThemeService
              ){
  }

  ngOnInit(): void {
    // responsive handled via lxViewport in template
  }

  toggleAcknowledgment(){
    this.acknowledgment = !this.acknowledgment;
  }

  getGuestInfo(offer_alias_id: string, prop_id: string): Observable<GuestDTO>{
    return this.offerService.getGuestInfo(offer_alias_id, prop_id).pipe(shareReplay(1));
  }

  acceptOffer() {
    if(this.offer && this.acknowledgment){

      setTimeout(() => {
        this.closeModal();
      }, 0)
      localStorage.setItem('offer', JSON.stringify(this.offer));

      let guestInfo$ = this.getGuestInfo(this.offerAliasId, this.propertyId).pipe(shareReplay(1));
      let guest_info: GuestDTO = {} as GuestDTO;
      guestInfo$.subscribe(res => {
          guest_info = res;
          if(this.offer){
            if(this.offer.confirmation_type === Notifications.email &&
              guest_info.has_guest_email === false) {
              this.closeModal();
              this.navigateToOfferFormEmail();
            } else if(this.offer.confirmation_type === Notifications.email ||
              this.offer.confirmation_type === Notifications.emailOrSms) {

              this.authService.requestUpgradeConfirmationValidation(this.offerAliasId,
                                                                    this.propertyId,
                                                                    this.offer.offer_set_id,
                                                                    this.offer.offer_id,
                                                                    this.offer.base_room_category_name,
                                                                    this.offer.bar_price)
              .subscribe(res => {
                this.closeModal();
                this.navigateConfirmationValidation();
              });
            }
          }
        });

    }
    else{

    }
  }

  closeModal(){
    this.modalRef.hide();
    document.body.style.overflow = 'auto';
    document.documentElement.style.overflow = 'auto';
    document.documentElement.classList.remove("modal-open");
    document.body.classList.remove("modal-open");
  }

  emptyCart(requestOnlyMode: boolean = false) {
    if (requestOnlyMode) {
      this.shoppingCartService.emptyCart(this.offerAliasId);
    }
  }

  closeModalAndEmptyCart() {
    this.emptyCart(this.sharedService.requestOnlyMode);
    this.closeModal();
  }

  navigateToOfferConfirmation(){
    this.router.navigate(['/offerConfirmation/' + this.offerAliasId + '/' + this.propertyId], { relativeTo: this.route })
  }

  navigateConfirmationValidation(){
    this.router.navigate(['/offerConfirmationValidation/' + this.offerAliasId + '/' + this.propertyId], { relativeTo: this.route })
  }

  navigateToOfferFormEmail(){
    this.router.navigate(['/offerGuestEmail/' + this.offerAliasId + '/' + this.propertyId], { relativeTo: this.route })
  }

  notifications = {
    "E": "You'll receive an email with the outcome. If we're unable to fulfill your request, it’s likely due to availability.",
    "S": "You'll receive an SMS update on whether your upgrade request has been accepted",
    "ES": "You'll receive an email or SMS update on whether your upgrade request has been accepted",
    "L": "You'll be given a request status link indicating whether your upgrade request has been accepted.  Additionally, upon check-in, a hotel team member will advise if your upgrade has been accepted.",
    "N": "Upon check-in, a hotel team member will advise if your upgrade has been accepted.",
  }

  public getNotification(conf_type: string){
    let key = conf_type as keyof typeof this.notifications;
    return this.notifications[key];
  }

  public getUpsellName(offer: Offer): string {
    let upsellName = ''
    if (offer.amenities) {
      upsellName = offer.amenities.upsell_room_name;
    } else {
      upsellName = offer.upsell_room_category_name;
    }

    return upsellName;
  }

  public calculateTotalQuantity(offer: any[]): number {
    return this.shoppingCartService.calculateTotalQuantity(offer);
  }

  public calculateTotalPrice(offer: any[]): number {
    return this.shoppingCartService.calculateTotalPrice(offer);
  }

  public calculateQuantity(offer: any): number {
    return this.shoppingCartService.calculateQuantity(offer);
  }

  public calculatePrice(offer: any): number {
    return this.shoppingCartService.calculatePrice(offer);
  }

  removeOfferFromCart(event: { offer: any, aliasId?: string }) {
    this.shoppingCartService.removeOfferFromCart(event.offer, event.aliasId!);
    this.offers = this.offers.filter(o => o !== event.offer);

    if (this.offers.length === 0) {
      this.closeModal();
    }

  }

}
